var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("openstack-uicore-foundation", [], t) : "object" == typeof exports ? exports["openstack-uicore-foundation"] = t() : e["openstack-uicore-foundation"] = t();
}(this, function () {
  return function () {
    "use strict";

    var e = {
        5097: function _(e, t, n) {
          n.d(t, {
            CLEAR_SESSION_STATE: function CLEAR_SESSION_STATE() {
              return o;
            }
          });
          n(1116), n(6842), n(9087), n(9558), n(1742);
          var o = "CLEAR_SESSION_STATE";
        },
        1742: function _(e, t, n) {
          n.d(t, {
            doLogin: function doLogin() {
              return b;
            },
            initLogOut: function initLogOut() {
              return I;
            }
          });
          var o = n(9558);
          n(5812), n(806);
          var r = require("browser-tabs-lock");
          var s = n.n(r);
          require("js-cookie");
          var i = n(8041),
            l = n.n(i);
          n(9891), n(5097);
          var u = require("crypto-js/sha256");
          var d = n.n(u);
          var c = require("crypto-js/enc-base64url");
          var p = n.n(c);
          var f = require("crypto-js/enc-hex");
          var g = n.n(f);
          var w = 65536,
            y = "undefined" != typeof window ? window.crypto || window.msCrypto : null;
          new (s())();
          var h = "code",
            S = "authInfo",
            _ = "nonce",
            m = "pkce",
            R = function R(e) {
              var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
                n = "";
              for (var _o = 0; _o < e; _o++) {
                n += t.charAt(Math.floor(62 * Math.random()));
              }
              return n;
            },
            b = function b() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              var i = function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
                var a = k(),
                  u = (0, o.getAuthCallback)(),
                  d = C(),
                  c = v(),
                  p = A();
                null != e && (u += "?BackUrl=".concat(encodeURI(e)));
                var f = R(16);
                (0, o.putOnLocalStorage)(_, f);
                var g = l()("".concat(d, "/oauth2/auth")),
                  w = {
                    response_type: encodeURI(p),
                    scope: encodeURI(c),
                    nonce: f,
                    response_mode: "fragment",
                    client_id: encodeURI(a),
                    redirect_uri: encodeURI(u)
                  };
                if (p === h) {
                  var _e = O();
                  (0, o.putOnLocalStorage)(m, JSON.stringify(_e)), w.code_challenge = _e.codeChallenge, w.code_challenge_method = "S256", w.approval_prompt = "force";
                }
                return t && (w.prompt = t), c && c.includes("offline_access") && (w.prompt = "consent"), n && (w.id_token_hint = n), r && (w.provider = r), i && (w.otp_login_hint = i), s && (w.login_hint = encodeURI(s)), g = g.query(w), g;
              }(e, n, null, t, r, s);
              (0, o.getCurrentLocation)().replace(i.toString());
            },
            O = function O() {
              var e = (0, o.base64URLEncode)(function (e) {
                if (e > 4294967295) throw new RangeError("requested too many random bytes");
                var t = Buffer.allocUnsafe(e);
                if (!y) return a;
                if (e > 0) if (e > w) for (var _n = 0; _n < e; _n += w) {
                  y.getRandomValues(t.slice(_n, _n + w));
                } else y.getRandomValues(t);
                return t;
              }(64));
              return {
                codeVerifier: e,
                codeChallenge: function (e) {
                  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hex";
                  var n = g();
                  return "Base64url" === t && (n = p()), d()(e).toString(n);
                }(e, "Base64url"),
                createdAt: new Date()
              };
            },
            E = function E() {
              try {
                var _e2 = (0, o.getFromLocalStorage)(S, !1);
                return _e2 ? JSON.parse(_e2) : null;
              } catch (e) {
                return null;
              }
            },
            L = function L() {
              if ("undefined" != typeof window) {
                var _e3 = E();
                return _e3 ? _e3.idToken : null;
              }
              return null;
            },
            k = function k() {
              return "undefined" != typeof window ? window.OAUTH2_CLIENT_ID : null;
            },
            A = function A() {
              return "undefined" != typeof window && window.OAUTH2_FLOW || "token id_token";
            },
            C = function C() {
              return "undefined" != typeof window ? window.IDP_BASE_URL : null;
            },
            v = function v() {
              return "undefined" != typeof window ? window.SCOPES : null;
            },
            I = function I() {
              (0, o.getCurrentLocation)().replace(function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var t = C(),
                  n = k(),
                  r = l()("".concat(t, "/oauth2/end-session")),
                  s = R(16),
                  i = "".concat((0, o.getOrigin)(), "/auth/logout");
                (0, o.putOnLocalStorage)("post_logout_state", s);
                var a = {
                  post_logout_redirect_uri: encodeURI(i),
                  client_id: encodeURI(n),
                  state: s
                };
                return e && (a.id_token_hint = e), r.query(a);
              }(L()).toString());
            };
        },
        9087: function _(e, t, n) {
          n.r(t), n.d(t, {
            CLEAR_MESSAGE: function CLEAR_MESSAGE() {
              return O;
            },
            GENERIC_ERROR: function GENERIC_ERROR() {
              return S;
            },
            RESET_LOADING: function RESET_LOADING() {
              return _;
            },
            SHOW_MESSAGE: function SHOW_MESSAGE() {
              return E;
            },
            START_LOADING: function START_LOADING() {
              return m;
            },
            STOP_LOADING: function STOP_LOADING() {
              return R;
            },
            VALIDATE: function VALIDATE() {
              return b;
            },
            authErrorHandler: function authErrorHandler() {
              return U;
            },
            createAction: function createAction() {
              return L;
            },
            defaultErrorHandler: function defaultErrorHandler() {
              return V;
            },
            deleteRequest: function deleteRequest() {
              return G;
            },
            downloadFileByContent: function downloadFileByContent() {
              return X;
            },
            escapeFilterValue: function escapeFilterValue() {
              return te;
            },
            fetchErrorHandler: function fetchErrorHandler() {
              return J;
            },
            fetchResponseHandler: function fetchResponseHandler() {
              return Y;
            },
            getCSV: function getCSV() {
              return Z;
            },
            getHeaderCaseInsensitive: function getHeaderCaseInsensitive() {
              return z;
            },
            getRawCSV: function getRawCSV() {
              return ee;
            },
            getRequest: function getRequest() {
              return M;
            },
            postFile: function postFile() {
              return $;
            },
            postRequest: function postRequest() {
              return H;
            },
            putFile: function putFile() {
              return F;
            },
            putRequest: function putRequest() {
              return D;
            },
            resetLoading: function resetLoading() {
              return k;
            },
            responseHandler: function responseHandler() {
              return W;
            },
            showMessage: function showMessage() {
              return K;
            },
            showSuccessMessage: function showSuccessMessage() {
              return Q;
            },
            startLoading: function startLoading() {
              return A;
            },
            stopLoading: function stopLoading() {
              return C;
            }
          });
          var o = n(2462),
            r = n.n(o),
            s = n(806),
            i = n.n(s),
            a = n(8041),
            l = n.n(a),
            u = n(9236),
            d = n.n(u),
            c = n(6842),
            p = n.n(c),
            f = n(9558),
            g = n(5097),
            w = n(1742);
          var y = ["access_token"];
          var h = i();
          var S = "Yikes. Something seems to be broken. Our web team has been notified, and we apologize for the inconvenience.",
            _ = "RESET_LOADING",
            m = "START_LOADING",
            R = "STOP_LOADING",
            b = "VALIDATE",
            O = "CLEAR_MESSAGE",
            E = "SHOW_MESSAGE",
            L = function L(e) {
              return function (t) {
                return {
                  type: e,
                  payload: t
                };
              };
            },
            k = L(_),
            A = L(m),
            C = L(R),
            v = {},
            I = {},
            q = function q(e) {
              return 0 === Object.keys(e).length && e.constructor === Object;
            },
            x = function x(e, t, n, o) {
              return {
                httpCode: e,
                title: t,
                html: n,
                type: o
              };
            },
            T = function T(e, t, n) {
              return x(e, t, n, "error");
            },
            P = function P(e, t, n) {
              return x(e, t, n, "warning");
            },
            j = function j() {
              return function (e) {
                var t = (0, f.getCurrentPathName)(),
                  n = (0, f.isClearingSessionState)();
                e({
                  type: g.CLEAR_SESSION_STATE,
                  payload: {}
                }), n || ((0, f.setSessionClearingState)(!0), console.log("authErrorHandler 401 - re login"), (0, w.doLogin)(t));
              };
            },
            N = function N(e, t) {
              q(t) || Object.keys(t).forEach(function (n) {
                var o = t[n];
                Array.isArray(o) ? o.forEach(function (t) {
                  e.field("".concat(n, "[]"), t);
                }) : e.field(n, o);
              });
            },
            U = function U(e, t) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : K;
              return function (t) {
                var o, r;
                var s = e.status;
                var i,
                  a,
                  l = "";
                switch (t(C()), s) {
                  case 401:
                    n !== K ? (i = T(s, "ERROR", p().translate("errors.user_not_auth")), a = function a() {
                      return t(j());
                    }) : t(j());
                    break;
                  case 403:
                    i = T(s, "ERROR", p().translate("errors.user_not_authz")), a = w.initLogOut;
                    break;
                  case 404:
                    l = (null === (o = e.response.body) || void 0 === o ? void 0 : o.message) || (null === (r = e.response.error) || void 0 === r ? void 0 : r.message) || e.message, i = P(s, "Not Found", l);
                    break;
                  case 412:
                    for (var _i = 0, _Object$entries = Object.entries(e.response.body.errors); _i < _Object$entries.length; _i++) {
                      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                        _t = _Object$entries$_i[0],
                        _n2 = _Object$entries$_i[1];
                      l += isNaN(_t) ? "".concat(_t, ": ") : "", l += "".concat(_n2, "<br>");
                    }
                    t({
                      type: b,
                      payload: {
                        errors: e.response.body.errors
                      }
                    }), i = P(s, "Validation error", l);
                    break;
                  default:
                    i = T(s, "ERROR", p().translate("errors.server_error"));
                }
                i && t(n(i, a));
              };
            },
            M = function M(e, t, n) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : V;
              var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
              var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
              return function () {
                var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return function (u, d) {
                  var c = l()(n),
                    p = c.toString();
                  if (!q(a)) {
                    var _e4 = a.access_token,
                      _t2 = r()(a, y);
                    p = c.query(_t2).toString(), c = c.query(a);
                  }
                  return e && "function" == typeof e && u(e(s)), function (e) {
                    v[e] && (v[e].abort(), console.log("aborted request ".concat(e)), delete v[e]);
                  }(p), new Promise(function (e, n) {
                    var r = h.get(c.toString());
                    if (i && I.hasOwnProperty(p)) {
                      var _e5 = I[p].etag;
                      _e5 && r.set("If-None-Match", _e5);
                    }
                    r.timeout({
                      response: 6e4,
                      deadline: 6e4
                    }).end(W(u, d, t, o, e, n, p, i)), function (e, t) {
                      v[e] = t;
                    }(p, r);
                  });
                };
              };
            },
            D = function D(e, t, n, o) {
              var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : V;
              var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
              return function () {
                var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return function (a, u) {
                  var d = l()(n);
                  return q(i) || (d = d.query(i)), e && "function" == typeof e && a(e(s)), new Promise(function (e, n) {
                    null == o && (o = {}), h.put(d.toString()).send(o).end(W(a, u, t, r, e, n));
                  });
                };
              };
            },
            G = function G(e, t, n, o) {
              var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : V;
              var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
              return function (i) {
                return function (a, u) {
                  var d = l()(n);
                  return q(i) || (d = d.query(i)), e && "function" == typeof e && a(e(s)), new Promise(function (e, n) {
                    null == o && (o = {}), h.delete(d).send(o).end(W(a, u, t, r, e, n));
                  });
                };
              };
            },
            H = function H(e, t, n, o) {
              var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : V;
              var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
              return function () {
                var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return function (a, u) {
                  var d = l()(n);
                  return q(i) || (d = d.query(i)), e && "function" == typeof e && a(e(s)), new Promise(function (e, n) {
                    var s = h.post(d);
                    null != o ? s.send(o) : s.set("Content-Type", "text/plain"), s.end(W(a, u, t, r, e, n));
                  });
                };
              };
            },
            $ = function $(e, t, n, o) {
              var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
              var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : V;
              var i = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
              return function () {
                var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return function (u, d) {
                  var c = l()(n);
                  return q(a) || (c = c.query(a)), e && "function" == typeof e && u(e(i)), new Promise(function (e, n) {
                    var i = h.post(c).attach("file", o);
                    N(i, r), i.end(W(u, d, t, s, e, n));
                  });
                };
              };
            },
            F = function F(e, t, n) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
              var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : V;
              var i = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
              return function () {
                var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return function (u, d) {
                  var c = l()(n);
                  return q(a) || (c = c.query(a)), e && "function" == typeof e && u(e(i)), new Promise(function (e, n) {
                    var i = h.put(c);
                    null != o && i.attach("file", o), N(i, r), i.end(W(u, d, t, s, e, n));
                  });
                };
              };
            },
            V = function V(e, t) {
              return function (e) {
                var n = t.body,
                  o = "";
                n instanceof Object && n.hasOwnProperty("message") && (o = n.message), d().fire(t.statusText, o, "error");
              };
            },
            B = function B(e) {
              return e.toLowerCase();
            },
            z = function z(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var n = function (e) {
                return Object.keys(e);
              }(t).find(function (e) {
                return function (t) {
                  return B(t) === e;
                };
              }(e));
              return n ? t[n] : void 0;
            },
            W = function W(e, t, n, o, r, s) {
              var i = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
              var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
              return function (l, u) {
                if (l || !u.ok) {
                  if (304 === l.status && I.hasOwnProperty(i) && a) {
                    var _t3 = I[i].body;
                    return "function" == typeof n ? (e(n({
                      response: _t3
                    })), r({
                      response: _t3
                    })) : (e(n), r({
                      response: _t3
                    }));
                  }
                  return o && o(l, u)(e, t), s({
                    err: l,
                    res: u,
                    dispatch: e,
                    state: t
                  });
                }
                var d = u.body;
                if (a) {
                  var _e6 = z("etag", u.headers);
                  _e6 && (I[i] = {
                    etag: _e6,
                    body: d
                  });
                }
                return "function" == typeof n ? (e(n({
                  response: d
                })), r({
                  response: d
                })) : (e(n), r({
                  response: d
                }));
              };
            },
            J = function J(e) {
              var t = e.status,
                n = e.statusText;
              switch (t) {
                case 403:
                  d().fire("ERROR", p().translate("errors.user_not_authz"), "warning");
                  break;
                case 401:
                  d().fire("ERROR", p().translate("errors.session_expired"), "error");
                  break;
                case 412:
                  d().fire("ERROR", n, "warning");
                case 500:
                  d().fire("ERROR", p().translate("errors.server_error"), "error");
              }
            },
            Y = function Y(e) {
              if (e.ok) return e.json();
              throw e;
            },
            K = function K(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return function (n) {
                n(C()), d().fire(e).then(function (e) {
                  e.value && "function" == typeof t && t();
                });
              };
            },
            Q = function Q(e) {
              return function (t) {
                t(C()), d().fire({
                  title: p().translate("general.done"),
                  html: e,
                  type: "success"
                });
              };
            },
            X = function X(e, t, n) {
              var o = document.createElement("a");
              o.textContent = "download", o.download = e, o.href = "data:".concat(n, ",").concat(encodeURIComponent(t)), document.body.appendChild(o), o.click(), document.body.removeChild(o);
            },
            Z = function Z(e, t, n) {
              var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              return function (r) {
                var s = l()(e);
                return q(t) || (s = s.query(t)), r(A()), fetch(s.toString()).then(function (e) {
                  if (e.ok) return e.text();
                  throw e;
                }).then(function (e) {
                  r(C()), o && (e = o + "\r\r" + e), X(n, e, "text/csv;charset=utf-8");
                }).catch(J);
              };
            },
            ee = function ee(e, t) {
              var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var o = l()(e);
              return q(t) || (o = o.query(t)), fetch(o.toString()).then(function (e) {
                if (e.ok) return e.text();
                throw e;
              }).then(function (e) {
                return n && (e = n + "\r\r" + e), e;
              }).catch(J);
            },
            te = function te(e) {
              return e = (e = e.replace(/,/g, "\\,")).replace(/;/g, "\\;"), encodeURIComponent(e);
            };
        },
        9558: function _(e, t, n) {
          n.d(t, {
            base64URLEncode: function base64URLEncode() {
              return p;
            },
            getAuthCallback: function getAuthCallback() {
              return o;
            },
            getCurrentLocation: function getCurrentLocation() {
              return r;
            },
            getCurrentPathName: function getCurrentPathName() {
              return i;
            },
            getFromLocalStorage: function getFromLocalStorage() {
              return l;
            },
            getOrigin: function getOrigin() {
              return s;
            },
            isClearingSessionState: function isClearingSessionState() {
              return d;
            },
            putOnLocalStorage: function putOnLocalStorage() {
              return a;
            },
            setSessionClearingState: function setSessionClearingState() {
              return c;
            }
          });
          n(5812), n(8041);
          var o = function o() {
              return "undefined" != typeof window ? "".concat(window.location.origin, "/auth/callback") : null;
            },
            r = function r() {
              var e = "";
              return "undefined" != typeof window && (e = window.location, window.top && (e = window.top.location)), e;
            },
            s = function s() {
              return "undefined" != typeof window ? window.location.origin : null;
            },
            i = function i() {
              return "undefined" != typeof window ? window.location.pathname : null;
            },
            a = function a(e, t) {
              "undefined" != typeof window && window.localStorage.setItem(e, t);
            },
            l = function l(e, t) {
              if ("undefined" != typeof window) {
                var _n3 = window.localStorage.getItem(e);
                return t && (console.log("getFromLocalStorage removing key ".concat(e)), u(e)), _n3;
              }
              return null;
            },
            u = function u(e) {
              "undefined" != typeof window && window.localStorage.removeItem(e);
            },
            d = function d() {
              return "undefined" != typeof window && window.clearing_session_state;
            },
            c = function c(e) {
              "undefined" != typeof window && (window.clearing_session_state = e);
            },
            p = function p(e) {
              return e.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
            };
        },
        1116: function _(e) {
          e.exports = require("@babel/runtime/helpers/defineProperty");
        },
        2462: function _(e) {
          e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
        },
        6842: function _(e) {
          e.exports = require("i18n-react/dist/i18n-react");
        },
        9891: function _(e) {
          e.exports = require("idtoken-verifier");
        },
        5812: function _(e) {
          e.exports = require("moment-timezone");
        },
        806: function _(e) {
          e.exports = require("superagent/lib/client");
        },
        9236: function _(e) {
          e.exports = require("sweetalert2");
        },
        8041: function _(e) {
          e.exports = require("urijs");
        }
      },
      t = {};
    function n(o) {
      var r = t[o];
      if (void 0 !== r) return r.exports;
      var s = t[o] = {
        exports: {}
      };
      return e[o](s, s.exports, n), s.exports;
    }
    return function () {
      n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, {
          a: t
        }), t;
      };
    }(), function () {
      n.d = function (e, t) {
        for (var o in t) {
          n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
          });
        }
      };
    }(), function () {
      n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      };
    }(), function () {
      n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      };
    }(), n(9087);
  }();
});